import { ReactNode } from 'react';

import { useRouteRef } from '@backstage/core-plugin-api';

import {
  AutocompleteEmptyState,
  ConfidenceAutocomplete,
} from '@spotify/confidence-core-react';
import { useEntitiesLazyQuery } from '@spotify/confidence-graphql';

import { entitiesRouteRef } from '../../routes';

type EntitySelectProps = {
  value?: string;
  label?: string;
  id?: string;
  onChange: (newValue: string) => void;
  disabled?: boolean;
  helperText?: ReactNode;
  required?: boolean;
};

export function EntitySelect({
  value,
  label = 'Entity',
  onChange,
  disabled,
  id,
  helperText,
  required,
}: EntitySelectProps) {
  const entitiesRoute = useRouteRef(entitiesRouteRef);

  return (
    <ConfidenceAutocomplete
      query={useEntitiesLazyQuery}
      id={id}
      disabled={disabled}
      autoSelectSingle
      label={label}
      required={required}
      data-testid="entity-select"
      value={value}
      onChange={(_e, entity) => onChange(entity || '')}
      helperText={helperText}
    >
      <AutocompleteEmptyState
        title="No entities"
        description={helperText}
        actionLabel="Create entity"
        actionLink={entitiesRoute?.()}
      />
    </ConfidenceAutocomplete>
  );
}
